import { createApi } from "@reduxjs/toolkit/dist/query/react"
import { API_CORE_URL } from "constants/config"
import { authBaseQuery } from "../api"

if (!API_CORE_URL) {
  throw new Error("REACT_APP_API_CORE_URL is not defined")
}

export const coreApi = createApi({
  reducerPath: "coreApi",
  baseQuery: authBaseQuery(API_CORE_URL),
  tagTypes: [
    "AccessLog",
    "DataBridgesApiKeys",
    "Currencies",
    "Country",
    "AdminUnit1",
    "AdminUnit2",
    "Markets",
    "NavigationMenu",
    "PriceType",
    "Users",
    "UsersRole",
    "UserPermission",
    "AssociatedCountries",
    "ApiKeys",
    "ApiKey",
    "ProviderPlatforms",
    "Commodities",
    "CommodityCategories",
    "CommodityUnits",
    "Series",
    "ApiKeyList",
    "Projects",
    "Forms",
  ],
  endpoints: () => ({}),
})
